//#region src/internal/code-location.ts
/** Formats a verified source location for the issue-details response. */
function formatCodeLocation(codeLocation) {
	const output = ["## Code Location", ""];
	if (codeLocation.repository) output.push(`**Repository**: ${codeLocation.repository}`);
	if (codeLocation.path) output.push(`**Path**: ${codeLocation.path}`);
	if (codeLocation.line !== void 0) output.push(`**Line**: ${codeLocation.line}`);
	output.push(`**Source**: ${codeLocation.url}`, "");
	return `${output.join("\n")}\n`;
}
/** Selects Sentry's most relevant application frame: the last in-app frame. */
function findMostRelevantInAppFrame(frames) {
	return frames.findLast((frame) => frame.inApp === true);
}

//#endregion
export { findMostRelevantInAppFrame, formatCodeLocation };
//# sourceMappingURL=code-location-DW_YNpMG.js.map